<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="STOPA.TARIFAID.SINGULAR"></span></label> -->
              <div class="col-md-12">
                  <!-- <yt-fw-dropdown
                  [ModelName]="'tarifa'"
                  [GetName]="'get'"
                  [ModelProperty]="'Naziv'"
                  [OrderBy]="'Naziv'"
                  [AllowAddNew]='true'
                  formControlName="TarifaID"
                  name="cmbTarife"
                  [Type]="ID"
                  [ngClass]="{'is-invalid': submitted && fc.TarifaID.invalid}"
                  [Label]="'STOPA.TARIFAID.SINGULAR'">
                </yt-fw-dropdown> -->
                <yt-dropdown-picklist
                [ModelName]="'tarifa'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="true"
                formControlName="TarifaID"
                [Label]="'STOPA.TARIFAID.SINGULAR'"
                >
                </yt-dropdown-picklist>
                <div class="form-error" *ngIf="submitted && fc.TarifaID.invalid">
                    <span *ngFor="let validation of errorMessages.TarifaID">
                      <span class="error-message" *ngIf="fc.TarifaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
              </div>
            </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="STOPA.DATUM.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-fw-date-picker-popup
              name="txtDatum"
              formControlName="Datum"
              [ngClass]="{'is-invalid' : submitted && fc.Datum.invalid}"
              [Label]="'STOPA.DATUM.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                <span *ngFor="let validation of errorMessages.Datum">
                  <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="STOPA.IZNOS.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'number'"
              name="txtStopa"
              formControlName="Iznos"
              [ngClass]="{'is-invalid': submitted && fc.Iznos.invalid}"
              [Label]="'STOPA.IZNOS.SINGULAR'">
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Iznos.invalid">
                  <span *ngFor="let validation of errorMessages.Iznos">
                    <span class="error-message" *ngIf="fc.Iznos.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>